import { render, staticRenderFns } from "./SearchIllustrations.vue?vue&type=template&id=853ebf02&lang=html"
import script from "./SearchIllustrations.vue?vue&type=script&lang=js"
export * from "./SearchIllustrations.vue?vue&type=script&lang=js"
import style0 from "./SearchIllustrations.vue?vue&type=style&index=0&id=853ebf02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports